<template>
  <AuthenticatedLayout :activeMenuItem='props.collection' :title='title'>
    <PaddedLayout>
      <div class='flex flex-wrap py-2 justify-between items-center gap-2 w-full'>
        <h1 class='text-2xl'>{{ title }}</h1>
        <LinkButton :to='collection.getCreateUrl()'>Create {{ collection.getSingleLabel() }}</LinkButton>
      </div>
      <CollectionIndex :collection='props.collection' class='mt-4' />
    </PaddedLayout>
  </AuthenticatedLayout>
</template>

<script setup>

import AuthenticatedLayout from '@/components/layouts/authenticated-layout.vue';
import PaddedLayout from '@/components/layouts/padded-layout.vue';

import LinkButton from '@/components/buttons/link-button.vue';
import CollectionIndex from '@/components/indexes/collection-index.vue';

import { getCollection } from '@/kernel/collections';

const props = defineProps({
  collection: String
});

const collection = getCollection(props.collection);

const title = collection.getPluralLabel();

</script>